import { useContext, useEffect, useState } from "react";
import { GetMessageType } from "../services/Api/login";
import { GlobalContext } from "../contexts/global";
import { useIsFocused } from "@react-navigation/native";
import { Modal, StyleSheet, Text, View, TouchableOpacity } from "react-native";
import { Colors, Fonts } from "../styles";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";

export default function MessageTypeModal({ show, onPressMessage, title }) {
  const { setShowAlert, showAlert } = useContext(GlobalContext);
  const [messageType, setMessageType] = useState([]);
  const isFocus = useIsFocused();

  const getMessages = () => {
    GetMessageType()
      .then((value) => {
        setMessageType(value);
      })
      .catch((value) => {
      });
  };

  useEffect(() => {
    if (isFocus) {
      getMessages();
    }
  }, [isFocus]);

  const MessageButton = ({ message, value }) => (
    <TouchableOpacity
      onPress={() => onPressMessage(value)}
      style={styles.buttonView}
    >
      <Text style={styles.buttonText}>{message}</Text>
    </TouchableOpacity>
  );

  if (messageType.length > 0) {
    return (
      <Modal
        animationType="fade"
        transparent={true}
        style={{ backgroundColor: "#000" }}
        visible={!!show}
        statusBarTranslucent={true}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View style={styles.titleView}>
              <Icon name={"message-processing-outline"} size={40} />
              <Text style={styles.titleText}>
                {title ?? "Selecione uma das opções abaixo:"}
              </Text>
              {title ? (
                <Text style={styles.subTitleText}>
                  {"Selecione uma opção"}
                </Text>
              ) : null}
            </View>
            <View style={styles.messageView}>
              {messageType.map((message) => (
                <MessageButton
                  message={message.name}
                  value={message.value}
                  key={message.value}
                />
              ))}
            </View>
          </View>
        </View>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.3)",
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "80%",
  },
  titleView: {
    marginBottom: 8,
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_20,
    fontWeight: "bold",
    color: Colors.BLACK,
  },
  subTitleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.BLACK,
    marginTop: 8
  },
  buttonView: {
    backgroundColor: Colors.SECONDARY,
    marginVertical: 4,
    padding: 8,
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonText: {
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.WHITE,
  },
});
